import { application } from "../helpers/stimulus"

import DropdownController from "../controllers/navbar/dropdown_controller"
import NavbarController from "../controllers/navbar/navbar_controller"
import NavbarSlideController from "../controllers/navbar/navbar_slide_controller"
import ModalController from "../controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"

const setupNavbar = (): void => {
  application.register("navbar", NavbarController)
  application.register("navbar-dropdown", DropdownController)
  application.register("navbar-modal", ModalController)
  application.register("navbar-modal-trigger", ModalTriggerController)
  application.register("navbar-slide", NavbarSlideController)
  application.register("profile-menu-modal", ModalController)
  application.register("profile-menu-modal-trigger", ModalTriggerController)
}

export { setupNavbar }
